export default __webpack_public_path__ + "static/media/end_.239154f8.svg";